'use strict';
export type { WithDecayConfig } from './decay';
export { withDecay } from './decay';
export type { DecayAnimation } from './utils';
